<template>
  <el-dialog
    title="添加成员"
    :visible.sync="dialogVisible"
    width="720px"
    :close-on-click-modal="false"
    append-to-body
    @open="handleOpen"
  >
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-input
        v-model="keyword"
        placeholder="姓名/账号模糊搜索"
        clearable
        style="width: 220px"
        @keyup.enter.native="handleSearch"
        @clear="handleSearch"
      ></el-input>
      <el-select
        v-model="memberStatus"
        placeholder="全部状态"
        clearable
        style="width: 120px"
        @change="handleSearch"
      >
        <el-option label="可添加" value="available"></el-option>
        <el-option label="已在组" value="member"></el-option>
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <span class="selected-tip" v-if="selectedUsers.length > 0">
        已选 {{ selectedUsers.length }} 人
      </span>
    </div>

    <!-- 候选人列表 -->
    <el-table
      ref="candidateTable"
      :data="candidateList"
      v-loading="loading"
      border
      size="small"
      height="320"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="45" :selectable="isCandidateSelectable"></el-table-column>
      <el-table-column prop="capacityName" label="姓名" width="100"></el-table-column>
      <el-table-column prop="userCode" label="账号" width="130"></el-table-column>
      <el-table-column prop="deptName" label="所在部门" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="状态" width="70" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.alreadyMember ? 'info' : 'success'" size="mini">
            {{ scope.row.alreadyMember ? '已在组' : '可添加' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      :current-page="pagination.pageNo"
      :page-size="pagination.pageSize"
      :page-sizes="[20, 50, 100]"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next"
    ></el-pagination>

    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button
        type="primary"
        @click="handleSubmit"
        :loading="submitting"
        :disabled="selectedUsers.length === 0"
      >
        添加 {{ selectedUsers.length > 0 ? `(${selectedUsers.length})` : '' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { teamService } from './team.service';

export default {
  name: 'MemberSelectDialog',
  props: {
    visible: { type: Boolean, default: false },
    teamId: { type: String, default: '' },
    teamType: { type: String, default: 'task' }
  },
  data () {
    return {
      keyword: '',
      memberStatus: '',
      candidateList: [],
      selectedUsers: [],
      loading: false,
      submitting: false,
      pagination: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      }
    };
  },
  computed: {
    dialogVisible: {
      get () { return this.visible; },
      set (val) { this.$emit('update:visible', val); }
    }
  },
  methods: {
    handleOpen () {
      this.keyword = '';
      this.memberStatus = '';
      this.selectedUsers = [];
      this.pagination.pageNo = 1;
      this.loadCandidates();
    },
    loadCandidates () {
      this.loading = true;
      teamService.getUserCandidatesPage({
        teamId: this.teamId,
        teamType: this.teamType,
        keyword: this.keyword,
        memberStatus: this.memberStatus,
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize
      }).then(res => {
        const data = res.data || {};
        this.candidateList = data.rows || data.list || [];
        this.pagination.total = data.total || 0;
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSearch () {
      this.pagination.pageNo = 1;
      this.selectedUsers = [];
      this.$refs.candidateTable && this.$refs.candidateTable.clearSelection();
      this.loadCandidates();
    },
    handleCurrentChange (pageNo) {
      this.pagination.pageNo = pageNo;
      this.selectedUsers = [];
      this.$refs.candidateTable && this.$refs.candidateTable.clearSelection();
      this.loadCandidates();
    },
    handleSizeChange (pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.pageNo = 1;
      this.selectedUsers = [];
      this.$refs.candidateTable && this.$refs.candidateTable.clearSelection();
      this.loadCandidates();
    },
    handleSelectionChange (val) {
      // 过滤掉已在组的人员，不允许重复添加
      this.selectedUsers = val.filter(u => !u.alreadyMember);
    },
    isCandidateSelectable (row) {
      return !row.alreadyMember;
    },
    handleSubmit () {
      if (!this.selectedUsers.length) return;
      this.submitting = true;
      teamService.addMembers({
        teamId: this.teamId,
        userIds: this.selectedUsers.map(u => u.capacityCode)
      }).then(() => {
        this.$message.success(`成功添加 ${this.selectedUsers.length} 名成员`);
        this.dialogVisible = false;
        this.$emit('success');
      }).finally(() => {
        this.submitting = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;

  .selected-tip {
    font-size: 13px;
    color: #409eff;
    margin-left: 8px;
  }
}

.pagination {
  margin-top: 10px;
  text-align: right;
}
</style>
